<script setup>
import { computed } from 'vue';
import FileIcon from 'dashboard/components-next/icon/FileIcon.vue';

const props = defineProps({
  filename: { type: String, default: '' },
  contentType: { type: String, default: '' },
  previewUrl: { type: String, default: '' },
});

const isImage = computed(() => props.contentType?.startsWith('image/'));
const isVideo = computed(() => props.contentType?.startsWith('video/'));
const extension = computed(() =>
  (props.filename || '').split('.').pop().toLowerCase()
);
</script>

<template>
  <div
    class="flex items-center justify-center overflow-hidden rounded shrink-0 size-9 bg-n-slate-3"
  >
    <img
      v-if="isImage"
      :src="previewUrl"
      :alt="filename"
      class="object-cover size-full"
    />
    <!-- preload=metadata renders the first frame, enough to recognise the clip -->
    <video
      v-else-if="isVideo"
      :src="previewUrl"
      class="object-cover size-full"
      preload="metadata"
      muted
      playsinline
    />
    <FileIcon v-else :file-type="extension" class="text-n-slate-11" />
  </div>
</template>
